// @flow
import * as React from 'react';

import cs from './styles.pcss';
import images from '../images/images';

export default function VisualDemo(): React.Node {
  return (
    <div className={cs.visualDemoContainer}>
      <div className={cs.picturesContainer}>
        <div className={cs.heroPhoneStack}>
          <div className={cs.heroPhoneBack}>
            <div className={cs.heroPhoneBackInner}>
              <img
                className={cs.heroPhoneImage}
                src={images.heroPhoneStack}
                alt=""
                aria-hidden="true"
                loading="lazy"
              />
            </div>
          </div>
        </div>
        <div className={cs.entryFrame}>
          <img
            className={cs.entry}
            src={images.entry}
            alt="entry"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}
